import type { ExcelDownloadClient, ExcelDownloadResult } from "app/components/React/ExcelButton/ExcelClientDownload";
import type {
    LeadsExcelDownloadRequestDto,
    LeadsSearchRequestDto,
    LeadsSearchResponseDto,
} from "app/pages/sales-intelligence/modules/leads-search";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import { BASE_ENDPOINT_PATH } from "./const";

/**
 * Service for all "websites"-based endpoints
 */
export const createWebsitesApiService = (fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) => {
    const baseWebsitesPath = `${BASE_ENDPOINT_PATH}/websites`;

    return {
        fetchSearchResults(dto: LeadsSearchRequestDto, config?: PostConfigObject): Promise<LeadsSearchResponseDto> {
            return fetchService.post(baseWebsitesPath, dto, config);
        },

        exportToExcel(dto: LeadsExcelDownloadRequestDto): Promise<ExcelDownloadResult> {
            return excelDownloadClient(`${baseWebsitesPath}/excel`, dto);
        },
    };
};
